//#region ImportSection
import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Row,
  Table,
} from "reactstrap";
import { GetLanguageString, NoResult } from "../../helper/Components";
import moment from "moment";
import {
  convertUTCToLocalTime,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import ApiSyllabusBook from "../../config/setupsyllabus/ApiSetupBook";
import { IoAdd } from "react-icons/io5";
import UpdateMemberNisabBooks from "../../ahbab/UpdateMemberNisabBooks";
//#endregion ImportSection

const UpdateBooks = ({ tab13, memberId, setDiscard, discard, activeTab }) => {
  //#region stateSection
  const [open, setOpen] = useState("");
  const [memberNisab, setmemberNisab] = useState([]);
  const [showmemberNisabModel, setshowmemberNisabModel] = useState(false);
  const [currentitem, setcurrentitem] = useState([]);
  const [loading, setLoading] = useState(false);
  //#endregion stateSection
  //#region useEffectSection
  useEffect(() => {
    setLoading(true);

    if (tab13 === "active" || showmemberNisabModel === false) {
      ApiSyllabusBook()
        .GetMemberNisaabBooks({ MemberId: memberId })
        .then((res) => {
          setmemberNisab(res.data);
        });
      setLoading(false);
    }
  }, [tab13, memberId, showmemberNisabModel]);
  useEffect(() => {
    // Check if the active tab has changed
    if (tab13 === "active") {
      if (activeTab && activeTab !== "tab13") {
        setDiscard(!discard);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);
  //#endregion useEffectSection
  //#region functionSection
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const handleAddBook = (item) => {
    setshowmemberNisabModel(true);
    setcurrentitem(item);
  };

  //#endregion functionSection
  return (
    <>
      {!loading ? (
        <div role="tabpanel" id="tab-6" className={"tab-pane " + tab13}>
          <div className="panel-body">
            <div className="row pb-2">
              <div className="col-md-10"></div>
              <div className="col-md-2 d-flex justify-content-end">
                <Button color="default" size="sm" onClick={handleAddBook}>
                  <IoAdd
                    color="#18A689"
                    size={18}
                    style={{
                      marginRight: 3,
                      marginBottom: 1,
                    }}
                  />
                  {<GetLanguageString props="update_syllabus_books" />}
                </Button>
              </div>
            </div>
            {memberNisab?.length > 0 ? (
              <Row>
                <Col md="12">
                  {showmemberNisabModel && (
                    <UpdateMemberNisabBooks
                      memberId={memberId}
                      onClose={setshowmemberNisabModel}
                      currentItem={currentitem}
                    />
                  )}
                  {memberNisab?.map((item, index) => {
                    return (
                      <div key={index}>
                        <Accordion open={open} toggle={toggle} key={index}>
                          <AccordionItem>
                            <AccordionHeader targetId={(index + 1).toString()}>
                              <div className="container-fluid p-0">
                                <div className="row w-100">
                                  <div
                                    className={`col text-start ${
                                      isUrdu(item.name) ? "ur" : ""
                                    }`}
                                  >
                                    {item.name}
                                  </div>
                                  <div
                                    style={{
                                      direction: "ltr",
                                    }}
                                    className="col-auto text-end"
                                  >
                                    <span
                                      style={{
                                        backgroundColor: item.isCompleted
                                          ? "#28a745"
                                          : "#dc3545", // green / red
                                        color: "#fff", // white text
                                        padding: "4px 10px",
                                        borderRadius: "9999px", // full pill shape
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        display: "inline-block",

                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      <GetLanguageString
                                        props={
                                          item.isCompleted
                                            ? "courses_status_completed"
                                            : "courses_status_incompleted"
                                        }
                                      />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={(index + 1).toString()}>
                              <div className="table-responsive">
                                <Table responsive>
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>
                                        {
                                          <GetLanguageString props="syllabus_books_name" />
                                        }
                                      </th>

                                      <th style={{ textAlign: "center" }}>
                                        {
                                          <GetLanguageString props="dashboard_event_page_status" />
                                        }
                                      </th>
                                      <th style={{ textAlign: "center" }}>
                                        {<GetLanguageString props="read_at" />}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>{item.bookName}</tr>
                                    {item.memberSyllabusBooks.map(
                                      (record, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className="ur">
                                              {record.syllabusBookName}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              {record.isReading ? (
                                                <span
                                                  style={{
                                                    color: "green",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  ✔
                                                </span>
                                              ) : (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    fontSize: "16px",
                                                  }}
                                                >
                                                  x
                                                </span>
                                              )}
                                            </td>

                                            <td style={{ textAlign: "center" }}>
                                              {record.isReading
                                                ? record.completedAt
                                                  ? moment(
                                                      convertUTCToLocalTime(
                                                        record.completedAt
                                                      )
                                                    ).format("DD/MM/yyyy")
                                                  : ""
                                                : ""}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    );
                  })}
                </Col>
              </Row>
            ) : (
              <NoResult />
            )}
          </div>
        </div>
      ) : (
        LoadingSpinner()
      )}
    </>
  );
};

export default UpdateBooks;
